<div [class]="centered ? 'language-switcher-centered' : 'language-switcher'">
  <button mat-icon-button
          [matMenuTriggerFor]="languageMenu"
          aria-label="Language switcher"
          type="button"
  >
    <mat-icon>language</mat-icon>
  </button>

  <mat-menu #languageMenu="matMenu">
  <button [disabled]="isLanguageSelected(Language.ENGLISH)"
          (click)="switchLanguage(Language.ENGLISH)"
          mat-menu-item
          type="button"
  >
    {{'English' | translate}}
  </button>
  <button [disabled]="isLanguageSelected(Language.SPANISH)"
          (click)="switchLanguage(Language.SPANISH)"
          mat-menu-item
          type="button"
  >
    {{'Spanish' | translate}}
  </button>
  <button [disabled]="isLanguageSelected(Language.GERMAN)"
          (click)="switchLanguage(Language.GERMAN)"
          mat-menu-item
          type="button"
  >
    {{'German' | translate}}
  </button>
  <button [disabled]="isLanguageSelected(Language.FRENCH)"
          (click)="switchLanguage(Language.FRENCH)"
          mat-menu-item
          type="button"
  >
    {{'French' | translate}}
  </button>
  <button [disabled]="isLanguageSelected(Language.ITALIAN)"
          (click)="switchLanguage(Language.ITALIAN)"
          mat-menu-item
          type="button"
  >
    {{'Italian' | translate}}
  </button>
  <button [disabled]="isLanguageSelected(Language.PORTUGUESE)"
          (click)="switchLanguage(Language.PORTUGUESE)"
          mat-menu-item
          type="button"
  >
    {{'Portuguese' | translate}}
  </button>
</mat-menu>
</div>

